'use client'
import styled from 'styled-components'
import { hexToRgba, lightOrDark } from './HexToRGBA'
import { Link } from 'react-router-dom'

export const Button = styled(Link)`
    border-radius: 50px;
    background: ${props => (props.primary ? props.theme.mainColor : props.theme.secondaryColor)};
    white-space: nowrap;
    padding: ${({ big }) => (big ? '14px 48px' : '12px 38px')};
    color: ${props => (props.dark ? props.theme.secondaryBg : props.theme.mainBg)};
    font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
    outline: none;
    border: none;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: ${(props) => (props.primary ? props.theme.secondaryBg : props.theme.mainColor)};
        color: ${(props) => (props.primary ? props.theme.mainColor : props.theme.secondaryBg)};
    }
`

// Button Themes

// Button Themed

export const CustomButton= styled.button`
    border-radius: 50px;
    white-space: nowrap;
    padding: 0px 50%;
    color: ${(props) => props.background ? props.background : props.theme.secondaryBg};
    background: transparent;
    cursor: pointer;
    display: flex;
    width: auto;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    border: none;
    outline: none;

    &:hover {
        transition: all 0.2s ease-in-out;
        color: ${(props) => (props.active ? props.theme.mainBg : props.theme.secondaryColor)};
        border: ${(props) => props.outline ? '1px solid' : 'none'};

    }
`

export const HoverOption = styled.div`
    display:flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    padding: 2%;
    margin: 2%;
    border-radius: 50px;
    border: 1px solid ${props => props.theme.secondaryBg};
    &:hover {
        color: ${props => props.theme.mainBg}; 
        background-color: ${props => hexToRgba(props.theme.accentColor, 0.8)}; 
    }
`
export const Button1 = styled.button`
    border-radius: 20px;
    background: ${props => (props.primary ? props.theme.mainColor : props.theme.secondaryColor)};
    white-space: nowrap;
    padding: ${({ big }) => (big ? '14px 48px' : '12px 38px')};
    color: ${props => (props.dark ? props.theme.secondaryBg : props.theme.mainBg)};
    font-size: ${({ fontBig }) => (fontBig ? '1.2rem' : '0.9rem')};
    outline: none;
    border: none;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 2%;
    margin-bottom: 2%;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: ${(props) => (props.primary ? props.theme.secondaryBg : props.theme.mainColor)};
        color: ${(props) => (props.primary ? props.theme.mainColor : props.theme.secondaryBg)};
    }
    &:disabled {
    background-color: #4b5563;
    cursor: not-allowed;
    transform: none;
  }
`


export const CustomButton1 = styled.button`
    border-radius: 0.5rem;;
    background: ${props => (props.background ? props.background : props.theme.mainColor )};
    white-space: nowrap;
    padding: 2%;
   margin: 2%;
    color: ${props => (props?.background ? (lightOrDark(props.background) === 'light' ? 'black': 'white')  : props.theme.mainBg)};
    font-size: 0.9rem;
    outline: none;
    border: none;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: ${(props) => (props.background ? props.background: props.theme.secondaryBg)};
        color: ${(props) => (props?.background ? (lightOrDark(props.background) === 'light' ? 'black' : 'white') : props.theme.secondaryColor)};
    }
      @media screen and (max-width: 480px) {
    margin-top: 0;
    font-size: 1rem;
  }
`

export const ActionButton = styled.button`
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  color: ${props => props.theme.secondaryBg};
  transition: all 0.3s ease;
  background-color: ${props => props.colorType === "secondary" ? props => props.theme.secondaryColor : props => props.theme.mainColor};

  &:hover {
    filter: brightness(1.1);
  }
`;

export const OutlineButton = styled.button`
  flex: 1;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.75rem;
  border: 1px solid ${props => props.theme.secondaryColor};
  cursor: pointer;
  color: ${props => props.theme.secondaryBg};
  background: transparent;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.theme.mainBg};
    color:${props => props.theme.secondaryBg};
  }
`;